<template>
  <div class="box">
    <el-form :model="info" label-position="right" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm" size="small">
      <el-form-item label="标题" prop="title">
        <el-input v-model="info.title" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="banner_type">
        <el-select v-model="info.banner_type" placeholder="请选择">
          <el-option key="1" label="首页轮播" value="1"></el-option>
          <el-option key="2" label="首页广告图" value="2"></el-option>
          <el-option key="4" label="首页通知" value="4"></el-option>
          <el-option key="5" label="启动广告图" value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="图片" prop="img">
        <SelectImgs :selectNum="1" :selectData="[info.img]" :selectFunc="avatarChoose"></SelectImgs>
        <div class="mg-tp-20 pd-tp-20" v-if="info.banner_type==1">图片尺寸：750px * 360px</div>
        <div class="mg-tp-20 pd-tp-20" v-if="info.banner_type==2">图片尺寸：500px * 250px</div>
        <div class="mg-tp-20 pd-tp-20" v-if="info.banner_type==5">图片尺寸：750px * 1344px</div>
      </el-form-item>
      <el-form-item label="跳转类型" prop="jump_type">
        <el-radio-group v-model="info.jump_type" @change="changeJump()">
          <el-radio :label="0">不跳转</el-radio>
          <el-radio :label="1">商品列表</el-radio>
          <el-radio :label="2">商品详情</el-radio>
          <el-radio :label="3">单页详情</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="商品列表" prop="data_id" v-if="info.jump_type==1">
        <el-select v-model="info.data_id" placeholder="请选择">
          <el-option v-for="item in goodsMenu" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="跳转商品" prop="goods" v-if="info.jump_type==2">
        <div style="display: flex; align-items: center">
          <div class="goods-box" v-if="info.goods">
            <div class="item">
              <img :src="info.goods.img" class="img">
              <div class="name">{{info.goods.title}}</div>
            </div>
          </div>
          <el-button type="warning" @click="showModel=true">选择商品</el-button>
        </div>
      </el-form-item>
      <el-form-item label="选择单页" prop="data_id" v-if="info.jump_type==3">
        <el-select v-model="info.data_id" placeholder="请选择">
          <el-option v-for="item in onlyList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="排序" prop="ordering">
        <el-input v-model="info.ordering" placeholder="请输入序号">
          <template slot="append">序号，倒序</template>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <el-button type="button" @click="reBack()">返回</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
        title="选择商品"
        :visible.sync="showModel"
        :destroy-on-close="true"
        width="900px">
        <goods-list :type="1" :goodsType="2" :selectFunc="selectGoods"></goods-list>
    </el-dialog>
  </div>
</template>
<script>

import SelectImgs from '../../components/SelectImgs'
import GoodsList from "@/components/GoodsList";
export default {
  data() {
    return {
      showModel: false,
      goodsMenu: [],
      onlyList: [
        {id: 1, title: '用户协议'},
        {id: 2, title: '隐私协议'},
        {id: 3, title: '关于我们'},
        {id: 4, title: '联系我们'},
      ],
      info: {
        id: 0,
        title: '',
        banner_type: '',
        img: '',
        jump_type: '',
        data_id: '',
        ordering: '',
        goods: false
      },
      source_domain: this.config.SOURCE_DOMAIN,
      rules: {
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'}
        ],
        banner_type: [
          {required: true, message: '请选择类型', trigger: 'blur'}
        ]
      }
    };
  },
  created() {
    this.getGoodsMenu()
    if (this.$route.query.id) {
      this.info.id = this.$route.query.id
      this.getInfo()
    }
  },
  mounted() {
  },
  components: {
    SelectImgs,
    GoodsList
  },
  computed: {},
  methods: {
    avatarChoose(item) {
      this.info.img = item.pic
    },
    changeJump() {
      this.info.data_id = ''
    },
    getGoodsMenu() {
      this.$api.goods.menuList({}, res => {
        if (res.errcode == 0) {
          this.goodsMenu = res.data
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    getInfo() {
      var that = this
      this.$api.merchant.bannerDetail({id: that.info.id}, function (res) {
        if (res.errcode == 0) {
          that.info = res.data
          that.info.banner_type = String(that.info.banner_type)
        } else {
          that.fail(res.errmsg)
        }
      })
    },
    selectGoods(item) {
      this.info.goods = {
        id: item.id,
        title: item.title,
        img: item.img
      }
      this.info.data_id = item.id
      this.showModel = false
    },
    submitForm(formName) {
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var param = this.info
          if (this.info.id == 0) {
            this.$api.merchant.bannerAdd(param, function (res) {
              if (res.errcode == 0) {
                that.success(res.errmsg)
                that.reBack()
              } else {
                that.fail(res.errmsg)
              }
            })
          } else {
            this.$api.merchant.bannerEdit(param, function (res) {
              if (res.errcode == 0) {
                that.success(res.errmsg)
                that.reBack()
              } else {
                that.fail(res.errmsg)
              }
            })
          }
        } else {
          return false;
        }
      });
    },
  }
};
</script>
<style scoped>
.box {
  background-color: #fff;
  padding: 20px;
  border-radius: 6px;
  min-height: 500px;
}
</style>
